module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-6f1b26e194a22f3fe1c13635f6952fbd.png";